export function doesRectsIntersect(r1: DOMRect, r2: DOMRect) {
  return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
}

export function doesRect1Inside2(r1: DOMRect, r2: DOMRect) {
  return r1.left > r2.left && r1.right < r2.right && r1.top > r2.top && r1.bottom < r2.bottom;
}

export function padRect(r: DOMRect, pad: number) {
  return new DOMRect(r.x - pad, r.y - pad, r.width + pad * 2, r.height + pad * 2);
}

export function translateRect(r: DOMRect, [dx, dy]: [number, number]) {
  return new DOMRect(r.x + dx, r.y + dy, r.width, r.height);
}
